import { required, minLength, minValue } from 'react-admin';

export const validateTitle = [required()];

export const validateDescription = [required(), minLength(25)];

export const validatePositionInMenu = [required(), minValue(0)];

export const validateSortOrder = [required(), minValue(0)];
